const tabs = () =>
{
    const selectTab = (element) =>
    {
		if(!element)
			return false;

        const tabs = element.closest(".tabs")
        if (tabs)
        {
            const active = tabs.querySelector(".tabs-link--active");
            const visible = tabs.querySelector(".tabs-content--visible");
            const tabContent = tabs.querySelector(`[data-display = '${element.value}']`);
            const tabsLinks = tabs.querySelectorAll(".tabs-link");
            tabs.setAttribute("data-tab-active", "");

            tabsLinks.forEach((link) => {
                const activeItem = link.closest(".main-nav-tabs__item");

                if (element !== link)
                {
                    link.classList.remove("tabs-link--active");

                    if (activeItem)
                        activeItem.classList.remove("main-nav-tabs__item--active");
                }
                else
                {
                    element.classList.add("tabs-link--active");
                    tabs.setAttribute("data-tab-active", element.value);

                    if (activeItem)
                    {
                        activeItem.classList.add("main-nav-tabs__item--active");
                    }
                }
            });

            if (visible)
            {
                visible.classList.remove("tabs-content--visible")
            }

            tabContent.classList.add("tabs-content--visible")

            // only searcher tabs
            if (tabs.classList.contains("searcher__tabs"))
            {
                const searcherMapContainers = document.querySelectorAll(
                    ".searcher__map-container"
                );

                const searcherContainer = (searcherMapContainers[0]).closest(".searcher");

                if (searcherContainer && element.value)
                {
                    searcherContainer.setAttribute("data-type-selected", element.value);
                    const searcherTypeBackgrounds = searcherContainer.querySelectorAll(`.searcher__bg .tab-bg`);

                    if (searcherTypeBackgrounds)
                    {
                        searcherTypeBackgrounds.forEach((backgroundElement) => {
                            if (backgroundElement.getAttribute("data-type") === element.value)
                                backgroundElement.classList.add("active");
                            else
                                backgroundElement.classList.remove("active");
                        });
                    }
                }

                searcherMapContainers?.forEach((item) =>
                {
                    if (item.getAttribute("data-type") === element.value)
                        item.classList.add("visible");
                    else
                        item.classList.remove("visible");
                });
            }
        }
    }

    const tabLinks = document.querySelectorAll(".tabs-link")
    tabLinks.forEach((tabLink) =>
    {
        tabLink.addEventListener("click", (e) =>
        {
            selectTab(e.currentTarget)
        })
    });
}

export default tabs
